import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ListTileComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';

import { ClassSelectionComponent } from './class-selection.component';

@NgModule({
  declarations: [ClassSelectionComponent],
  imports: [CommonModule, ListTileComponent, SectionTitleComponent, ApmTranslatePipe],
  exports: [ClassSelectionComponent],
})
export class ClassSelectionModule {}
